module.exports = __webpack_public_path__ + "static/media/lucky-dragons.3b407349.gif";